<template>
  <v-container fill-height fluid pl-0 pr-0 align-start>
    <v-layout column>
      <div class="l-row">
        <v-container class="l-container">
          <div>
            <h1>{{ $t('LBL.MY_ASSESSMENTS') }}</h1>
          </div>
          <div class="text-xs-right">
            <v-spacer></v-spacer>
            <v-btn dark color="primary" @click="addChildDialog = !addChildDialog">
              {{ $t('LBL.ADD_CHILD') }}
              <v-icon right>face</v-icon>
            </v-btn>
          </div>
        </v-container>
        <hr>
      </div>

      <div v-if="userChildren.length === 0">
        <div class="empty-children-list l-row">
          <v-flex class="text-xs-center subheading">
            {{ $t('MSG.CHILD_LIST_EMPTY') }}
          </v-flex>
        </div>

        <hr>
      </div>

      <div v-for="child in userChildren" :key="child.id" class="children-list" v-if="appReady">
        <v-container class="child l-container">
          <div class="l-row">
            <child-clip :child="child"></child-clip>
          </div>

          <v-layout class="l-row">
            <v-flex v-for="(assessment, age) in assessments" :key="age">
              <div class="ass" :class="getAssessmentClasses(age, child.assessmentStatuses[age])"
                @click.prevent="child.assessmentStatuses[age] >= 0 && goToAssessmentDetail(child, age)">
                <div class="ass-icon" :class="getAssessmentCssClassByAge(age)">
                  <!-- <div class="inner" v-if="child.assessmentStatuses[age] === 1">
                    <v-icon>check_circle</v-icon>
                  </div>
                  <div class="inner" v-else>
                    {{ age }}
                  </div> -->
                  <div class="inner">
                    {{ age }}
                  </div>

                  <div class="icon-wrap-1" v-if="child.assessmentStatuses[age] === 0"
                    >
                    <div class="icon-wrap-2" :class="getAssessmentCssClassByAge(age)">
                      <v-icon>arrow_forward</v-icon>
                    </div>
                  </div>
                  <!-- <v-btn dark color="green" small absolute icon :ripple="false"
                    style="right: 0; bottom: 0; border: 3px solid #fff !important;"
                    v-if="child.assessmentStatuses[age] === 0">
                    <v-icon>arrow_forward</v-icon>
                  </v-btn> -->
                </div>
                <div class="ass-status">
                  <!-- <div class="lbl-likelihood" v-if="child.assessmentStatuses[age] >= 1">
                    {{ $t('LBL.LIKELIHOOD') }}
                  </div>
                  <v-btn dark color="red" :ripple="false" v-if="child.assessmentStatuses[age] === 2">
                    {{ $t('LBL.HIGH') }}
                  </v-btn>
                  <v-btn dark color="green" :ripple="false" v-else-if="child.assessmentStatuses[age] === 1">
                    {{ $t('LBL.LOW') }}
                  </v-btn>
                  <v-btn dark color="green" :ripple="false" :to="`/assessment/${child.id}/${age}`"
                    v-else-if="child.assessmentStatuses[age] === 0">
                    {{ $t('LBL.START') }}
                  </v-btn> -->
                  <v-btn flat color="red" large right :ripple="false" v-if="child.assessmentStatuses[age] === 2">
                    {{ $t('LBL.HIGH') }}
                  </v-btn>
                  <v-btn flat color="green" large right :ripple="false" v-else-if="child.assessmentStatuses[age] === 1">
                    {{ $t('LBL.LOW') }}
                  </v-btn>
                </div>
              </div>
            </v-flex>
          </v-layout>
        </v-container>

        <hr>
      </div>

      <div class="l-row white--text notes">
        <v-container v-html="$t('TXT.HOME_PAGE_FOOTER_NOTES_HTML')"></v-container>
      </div>
    </v-layout>

    <v-dialog
      content-class="dialog-top dialog-small" :width="$vuetify.breakpoint.smAndDown ? '80%' : '60%'"
      transition="slide-y-transition" origin="top center 0"
      v-model="introDialog" @keydown.esc="introDialog = false" >
      <v-card class="intro-dialog-content">
        <v-card-text v-html="$t('TXT.HOME_PAGE_INTRO_DIALOG_TEXT_HTML')"></v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn dark color="primary" @click.stop="introDialog = false">{{ $t('LBL.OK_GOT_IT')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <add-child-dialog :show.sync="addChildDialog"></add-child-dialog>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import AssessmentMixin from '@/components/mixins/AssessmentMixin'
import AddChildDialog from '@/components/dialogs/AddChildDialog'
import ChildClip from '@/components/elements/ChildClip'

export default {
  name: 'HomePage',
  components: {
    'add-child-dialog': AddChildDialog,
    'child-clip': ChildClip
  },
  computed: {
    ...mapState([
      'appReady',
      'assessments',
      'userChildren'
    ])
  },
  created () {
    this.$store.commit('UPDATE_APP_STEP', 3)
    this.refreshChildList()
  },
  data () {
    return {
      introDialog: false,
      showedIntroDialog: false,
      addChildDialog: false
    }
  },
  methods: {
    getAssessmentClasses (age, status) {
      const classes = []
      classes.push(`age${age}`)

      if (status === 0) {
        classes.push('open')
      } else if (status === 1) {
        classes.push('risk-low')
      } else if (status === 2) {
        classes.push('risk-high')
      } else {
        classes.push('disabled')
      }
      return classes
    },
    goToAssessmentDetail (child, age) {
      const assResult = child.assessmentStatuses[age]
      let url = ''
      if (assResult === 2 || assResult === 1) {
        url = `/assessment/${child.id}/${age}/review`
      } else if (assResult === 0) {
        url = `/assessment/${child.id}/${age}`
      }
      if (url) {
        this.$router.push(url)
      }
    },
    ...mapActions([
      'refreshChildList'
    ])
  },
  mixins: [
    AssessmentMixin
  ],
  watch: {
    appReady (appReady) {
      if (appReady && !this.showedIntroDialog) {
        // set the flag to true regardless dialog is displayed or not
        this.showedIntroDialog = true
        console.log('determining display the intro dialog or not')
        if (!this.userChildren.length) {
          this.introDialog = true
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/styles/_colors.scss';

hr {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}

.empty-children-list {
  min-height: 6em;
  display: flex;
  align-items: center;
}

.notes {
  @include bg-gradient-orange();
  font-weight: 700;

  .container {
    max-width: 900px;
  }
}

.children-list {
  .child {
    @include mq('md') {
      max-width: 85%;
    }
  }
}

.ass {
  $dimension: 84px;
  $disabled-color: #ccc;

  width: $dimension;
  margin: 0 auto;
  cursor: pointer;

  .ass-icon {
    $icon-inner-dimension: 84px - 12px - 6px;

    display: flex;
    justify-content: center;
    align-items: center;
    width: $dimension;
    height: $dimension;
    border-radius: 8px;
    position: relative;
    user-select: none;

    .inner {
      display: flex;
      justify-content: center;
      align-items: center;
      width: $icon-inner-dimension;
      height: $icon-inner-dimension;
      border-radius: $icon-inner-dimension / 2;
      background: #fff;
      text-align: center;
      font-weight: bold;
      font-size: 36px;

      .icon.material-icons {
        font-size: 56px;
        color: #499a22;
      }
    }

    .icon-wrap-1 {
      position: absolute;
      right: 2px;
      bottom: 2px;
      width: 28px;
      height: 28px;
      border-radius: 50%;
      background: #fff;

      .icon-wrap-2 {
        position: absolute;
        right: 4px;
        bottom: 4px;
        width: 20px;
        height: 20px;
        border-radius: 50%;

        .icon {
          color: #fff!important;left: -5px;
          position: absolute;
          top: -3px;
          font-size: 26px;
        }
      }
    }
  }

  // &.disabled {
  //   cursor: default;
  //   .ass-icon {
  //     background: $disabled-color !important;
  //     color: $disabled-color !important;
  //   }
  // }

  &.disabled {
    cursor: default;
    .ass-icon,
    .ass-icon .inner {
      border: 3px solid $disabled-color;
      background: transparent !important;
      color: $disabled-color !important;
    }
  }

  .ass-status {
    margin-top: 4px;

    .lbl-likelihood {
      text-align: center;
      color: #666;
      font-size: 13px;
      text-transform: uppercase;
      user-select: none;
    }

    .btn {
      transform: scale(0.954, 0.954) translateX(-2px);
      height: 20px;
      margin: 0;
      border-radius: 6px;
      box-shadow: none!important;
      text-transform: none;
    }
  }

  &.open {
    .ass-icon {
      box-shadow: 0px 10px 6px -4px rgba(0, 0, 0, 0.6);
    }
  }

  &.risk-high {
    .ass-icon,
    .ass-icon .inner {
      border: 3px solid $red-lighten2;
      background: transparent !important;
      color: $red-lighten2 !important;
    }
  }

  &.risk-low {
    .ass-icon,
    .ass-icon .inner {
      border: 3px solid $green-lighten2;
      background: transparent !important;
      color: $green-lighten2 !important;
    }
  }

  &.risk-high, &.risk-low {
    .ass-status {
      .btn {
        pointer-events: none;
        text-transform: uppercase;
        font-weight: 700;
      }
    }
  }
}

.intro-dialog-content {
  font-size: 1.3em;

  .card__text {
    padding: 24px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/HomePage.vue